import { NAVIGATION_IDS } from '../constants/navigationIds';
import { URLS } from '../constants/url';
import { UserRoles } from '../constants/userRoles';

const { SUPER_ADMIN, ADMIN } = UserRoles;

export interface NavigationItem {
  id: string;
  label: string;
  path: string;
  icon: string;
  iconSize?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  isSubItem?: boolean;
  children?: NavigationItem[];
  showDivider?: boolean;
  requiredRoles?: string[];
  /** When set, the item is disabled with tooltip if the user lacks edit permission. */
  disableWithoutPermission?: boolean;
}

export const navigationConfig: NavigationItem[] = [
  {
    id: NAVIGATION_IDS.EDIT_ART_EVENT,
    label: 'art-event',
    path: URLS.ART_EVENT,
    icon: 'grid',
    iconSize: 'medium',
    requiredRoles: [SUPER_ADMIN],
  },
  {
    id: NAVIGATION_IDS.DASHBOARD,
    label: 'nav-dashboard',
    path: URLS.ROOT,
    icon: 'stopwatch',
    iconSize: 'medium',
  },
  {
    id: NAVIGATION_IDS.USERS,
    label: 'nav-users',
    path: URLS.USERS,
    icon: 'users',
    iconSize: 'medium',
    requiredRoles: [SUPER_ADMIN, ADMIN], // Only Super Admins and Admins can manage users
  },
  {
    id: NAVIGATION_IDS.ROLES,
    label: 'nav-roles',
    path: URLS.ROLES,
    icon: 'users',
    iconSize: 'medium',
    requiredRoles: [SUPER_ADMIN], // Only super admin can manage roles
  },
  {
    id: NAVIGATION_IDS.BOOKINGS,
    label: 'nav-bookings',
    path: URLS.BOOKINGS,
    icon: 'calendar',
    iconSize: 'medium',
  },
  {
    id: NAVIGATION_IDS.EDIT_INVENTORY,
    label: 'nav-edit-inventory',
    path: URLS.EDIT_INVENTORY,
    icon: 'edit',
    iconSize: 'medium',
    requiredRoles: [SUPER_ADMIN],
    disableWithoutPermission: true,
  },
  {
    id: NAVIGATION_IDS.ALLOWLIST,
    label: 'nav-allowlist',
    path: URLS.ALLOWLIST,
    icon: 'check-circle',
    iconSize: 'medium',
    requiredRoles: [SUPER_ADMIN],
    disableWithoutPermission: true,
    children: [
      {
        id: NAVIGATION_IDS.ALLOWLIST_UPLOAD_AE,
        label: 'nav-upload-ae',
        path: URLS.ALLOWLIST_AE,
        icon: 'circle',
        iconSize: 'xsmall',
        isSubItem: true,
      },
      {
        id: NAVIGATION_IDS.ALLOWLIST_UPLOAD_SOV,
        label: 'nav-upload-inventory',
        path: URLS.ALLOWLIST_INVENTORY,
        icon: 'circle',
        iconSize: 'xsmall',
        isSubItem: true,
      },
      {
        id: NAVIGATION_IDS.ALLOWLIST_UPLOAD_ADVERTISERS,
        label: 'nav-upload-advertisers',
        path: URLS.ALLOWLIST_ADVERTISERS,
        icon: 'circle',
        iconSize: 'xsmall',
        isSubItem: true,
      },
      {
        id: NAVIGATION_IDS.ALLOWLIST_UPLOAD_CATEGORY,
        label: 'nav-upload-category',
        path: URLS.ALLOWLIST_CATEGORY,
        icon: 'circle',
        iconSize: 'xsmall',
        isSubItem: true,
      },
      {
        id: NAVIGATION_IDS.ALLOWLIST_UPLOAD_TYPE_OF_PURCHASE,
        label: 'nav-upload-type-of-purchase',
        path: URLS.ALLOWLIST_TYPE_OF_PURCHASE,
        icon: 'circle',
        iconSize: 'xsmall',
        isSubItem: true,
      },
    ],
  },
];
